var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cascader',{attrs:{"value":_vm.areaIdList,"data":_vm.dataList,"load-data":_vm.loadData},on:{"on-change":_vm.onTargetType}})}
var staticRenderFns = []

export { render, staticRenderFns }